import styled from "styled-components";

export const HeaderStyled = styled.div`
	height: 120px;
	position: relative;

	#sub-menu {
		margin-top: -1px;
	}

	a {
		text-decoration: none;
	}
`;

export const TitleContainer = styled.div`
	min-height: 30px;
	display: flex;
	align-items: center;
	gap: 4px;
	margin: 0 20px 16px 0;

	p {
		margin: 0;
		padding: 0;
	}

	img {
		max-height: 30px;
		max-width: 30px;
		width: 100%;
		height: 100%;
	}
`;

export const LabelButtonStore = styled.label`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const StoreMobileContainer = styled.div<{ fixed: boolean }>`
	position: ${(props) => (props.fixed ? "fixed" : "absolute")};
	top: 22px;
	right: 66px;
	z-index: 9999;

	.store-button-mobile {
		background-color: transparent;
		padding: 0;
		border: 1px solid #c6c6c6;
		min-width: 48px;
		height: 48px;
	}
`;

export const DrawerLoginInner = styled.div`
	.login__group {
		margin-bottom: 40px;
		display: flex;
		flex-direction: column;

		a span {
			gap: 3px;
		}
	}

	.relative__div {
		position: relative;
		display: flex;
	}
`;
